import React from "react";
import "./loadingMaskRow.scss";

const LoadingMaskRow = () => {
  return <div className="loadingWrapper loading-list-mask" />;
};
export default LoadingMaskRow;
